import { gql } from "apollo-boost";

export const GET_MY_NOTIFICATIONS = gql`
  query myNotifications($limit: Int) {
    myNotifications(limit: $limit) {
      unreadCount
      items {
        id
        type
        title
        message
        actionUrl
        readAt
        createdAt
      }
    }
  }
`;

export const MARK_NOTIFICATION_AS_READ = gql`
  mutation markNotificationAsRead($id: Int!) {
    markNotificationAsRead(id: $id) {
      id
      readAt
    }
  }
`;

export const MARK_ALL_NOTIFICATIONS_AS_READ = gql`
  mutation markAllNotificationsAsRead {
    markAllNotificationsAsRead
  }
`;
